/**
 * Redux store configuration
 */

import { configureStore } from '@reduxjs/toolkit';
import { accommodationReducer } from './accommodation';
import authReducer from './auth/authSlice';
import { billingReducer } from './billing';
import configReducer from './config/configSlice';
import { departmentsReducer } from './departments';
import { globalFiltersReducer } from './globalFilters';
import { kdsReducer } from './kds';
import { menuReducer } from './menu';
import menuExtractionsReducer from './menuExtractions/menuExtractionSlice';
import onboardingReducer from './onboardingSlice';
import { outletReducer } from './outlets';
import printersReducer from './printers/printerSlice';
import runningOrderReducer from './runningOrder/runningOrderSlice';
import { sectionReducer } from './sections';
import subscriptionPackagesReducer from './subscriptionPackagesSlice';
import { usersReducer } from './users';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    onboarding: onboardingReducer,
    config: configReducer,
    subscriptionPackages: subscriptionPackagesReducer,
    departments: departmentsReducer,
    menu: menuReducer,
    menuExtractions: menuExtractionsReducer,
    outlets: outletReducer,
    sections: sectionReducer,
    printers: printersReducer,
    runningOrder: runningOrderReducer,
    billing: billingReducer,
    globalFilters: globalFiltersReducer,
    users: usersReducer,
    accommodation: accommodationReducer,
    kds: kdsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types if needed
        ignoredActions: [],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
